module.exports = __webpack_public_path__ + "img/xinhu_template_3.01e90870.png";